const React = require('react');
const map = require('mn-utils/map');

const DataBlock = require('./DataBlock');
const {
  DisplayDataAdmin,
  DisplayIdAdmin,
  DisplayDateDetailedAdmin
} = require("../../../../../../dumb/DisplayData");

module.exports = (props) => {
  const data = props.data || {};
  const dataArr = [
    {
      title: 'ID',
      value: (
        <DisplayDataAdmin>
          {data.id}
        </DisplayDataAdmin>
      ),
    },
    {
      title: 'Console role',
      value: data.role,
    },
    {
      title: 'Created at',
      value: <DisplayDateDetailedAdmin date={data.created_at} />,
    }
  ];

  return (
    <div className="layoutRow fxwWrap m-15 mb34">
      {map(dataArr, (item, i) => (
        <div key={i} className="w1/4 w1/2@m w@m2 mt21 ph15">
          <DataBlock title={item.title} value={item.value} />
        </div>
      ))}
    </div>
  );
};
